import React from 'react';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import PropTypes from 'prop-types';

import useStyles from './useStyles';

const Alert = ({ severity, open, vertical, horizontal, handleClose, text }) => {
  const classes = useStyles({ vertical });

  return (
    <Snackbar
      className={classes.alert}
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
    >
      <MuiAlert onClose={handleClose} severity={severity}>
        {text}
      </MuiAlert>
    </Snackbar>
  );
};

Alert.propTypes = {
  severity: PropTypes.string,
  open: PropTypes.bool.isRequired,
  vertical: PropTypes.string,
  horizontal: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

Alert.defaultProps = {
  vertical: 'top',
  horizontal: 'right',
  severity: 'success',
};

export default Alert;



// WEBPACK FOOTER //
// ./src/sharedComponents/Alert/Alert.js